<template>
  <div class="event-full-nav-text">
    <canvas ref="canvas" :width="width" :height="height"> </canvas>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  data() {
    return {
      width: 0,
      height: 260,
      ctx: null,
      content: '',
      contentWidth: 0,
      offset: 0
    }
  },
  mounted() {
    this.initCanvas().then(() => {
      this.initAnimation()
    })

    window.addEventListener('resize', this.initCanvas)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initCanvas)
  },
  methods: {
    initCanvas() {
      return new Promise(resolve => {
        this.width = window.innerWidth

        setTimeout(() => {
          this.ctx = this.$refs.canvas.getContext('2d')
          this.ctx.font = '300px "Trade Gothic"'
          this.ctx.fillStyle = 'rgba(0, 0, 0, 0.1)'

          this.setContent()
          resolve()
        }, 100)
      })
    },
    setContent() {
      let string = this.title.toUpperCase() + ' '
      this.contentWidth = this.ctx.measureText(string).width
      let repeat = Math.ceil((window.innerWidth * 2) / this.contentWidth)

      if (repeat < 2) {
        repeat = 2
      }

      this.content = string.repeat(repeat)
    },
    initAnimation() {
      window.requestAnimationFrame(this.moveText)
    },
    moveText() {
      this.offset -= 2
      if (this.offset < this.contentWidth * -1) {
        this.offset = 0
      }
      this.ctx.clearRect(0, 0, this.width, this.height)
      this.ctx.fillText(this.content, this.offset, 250)
      window.requestAnimationFrame(this.moveText)
    }
  }
}
</script>

<style lang="scss">
.event-full-nav-text {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 200;
  font-size: 100px;
}
</style>
